import type { ReactNode } from 'react';
import { SigLabel } from '../components/atelier';

const QA: Array<{ q: string; a: ReactNode }> = [
  {
    q: 'Will LMcad replace my CAD?',
    a: (
      <>
        No, and we&rsquo;re not pretending it could. Whatever you run, whether
        that&rsquo;s <strong>CATIA</strong>, <strong>Creo</strong>,{' '}
        <strong>SolidWorks</strong>, <strong>NX</strong>,{' '}
        <strong>Onshape</strong>, or <strong>Fusion</strong>, that&rsquo;s
        where the serious work lives, and that&rsquo;s where it should stay.
        LMcad does the part you&rsquo;d rather skip: the{' '}
        <em style={{ fontFamily: 'var(--font-serif)', color: 'var(--accent)' }}>
          first draft
        </em>
        , and the small-to-mid assemblies that get a project moving.
      </>
    ),
  },
  {
    q: 'Does it do assemblies?',
    a: (
      <>
        Yes. Single parts are the foundation, and small assemblies work
        today: bracket plus fasteners, motor plus housing, valve plus
        manifold. Larger assemblies with full mates and machine hierarchies
        are actively in scope. Ask on the demo to see what&rsquo;s shipping
        this quarter.
      </>
    ),
  },
  {
    q: 'What formats do I get?',
    a: (
      <>
        <strong>STEP 203 + 214</strong> for round-trip into any major CAD.
        The same handoff your team already uses internally. Plus STL for
        printing, and a rendered PNG for documentation. That&rsquo;s the
        whole package. No proprietary file types.
      </>
    ),
  },
  {
    q: 'Can I edit the generated geometry directly?',
    a: (
      <>
        Through the parameter panel and through chat. Not by hand-writing
        code. You drag sliders for dimensions and re-prompt for shape
        changes; LMcad does the heavy lifting in the backend. The output
        you take home is the STEP file, not the build script.
      </>
    ),
  },
  {
    q: 'What counts as one credit?',
    a: (
      <>
        Any generation that goes through the LLM. The first draft costs
        one credit; a re-prompt that asks the model to change something
        costs one credit. Slider tweaks are free — moving a parameter is
        just a value change in the parametric model, no model call
        involved, so no credit is consumed. If the LLM thinks, you pay;
        if you&rsquo;re just dragging a number, you don&rsquo;t.
      </>
    ),
  },
  {
    q: 'Can I run it on-prem?',
    a: (
      <>
        No. LMcad is cloud-hosted, and that&rsquo;s the only deployment we
        offer. The Practice plan includes dedicated cloud capacity and the
        usual enterprise paperwork (SSO, SOC&nbsp;2, DPA), but the runtime
        stays with us so we can keep evolving it without breaking your
        workflow.
      </>
    ),
  },
];

export function FAQ() {
  return (
    <section id="faq" className="container section">
      <div className="block-head">
        <div>
          <SigLabel>Frequently asked</SigLabel>
          <h2>
            The honest <em>questions.</em>
          </h2>
        </div>
        <p className="lede">
          The ones we get on every demo. If yours isn&rsquo;t here, ask on the
          call. We&rsquo;d rather answer it in person.
        </p>
      </div>

      <div className="faq">
        {QA.map((item, i) => (
          <div className="faq-item" key={i}>
            <div className="num">{String(i + 1).padStart(2, '0')}</div>
            <div>
              <h4>{item.q}</h4>
              <p>{item.a}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
